// extracted by mini-css-extract-plugin
export default {"header":"header___O0olf","title":"title___n_myG","description":"description___e86ZU","highlight":"highlight___UmIj6","segmented":"segmented___AScSh"};